export const RESET_LOADING = 'utilities@reset-loading';
export const SET_LOADING = 'utilities@set-loading';
export const SET_LOADING_PROGRESS = 'utilities@set-loading-progress';

export const SET_SNACK = 'utilities@set-snack';
export const RESET_SNACK = 'utilities@reset-snack';
export const SET_COMPONENT_LOADING = 'utilities@set-component-loading';
